import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { UtilService } from '@services/util/util.service';
import { API_ENDTPOINTS } from '@models/api-endpoints';
@Injectable({
  providedIn: 'root'
})
export class PortfolioService {

  public APIURL = environment.APP.BASE_URL;
  public CORE_API = environment.APP.CORE_API;
  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  constructor(
    public http: HttpClient,
    public util: UtilService
  ) { }
  /**
   * Get the details of successfully donations
   * of the user
   * @param qParam Query params
   */
  getBeneficiaries(qParam) {
    this.util.isToken = true;
    const url = this.APIURL + API_ENDTPOINTS.GET_USER_ORDERS;
    return this.http.get(url + qParam, this.httpOptions);
  }
  /**
   * Get the user summery like funds, doantions
   * average donations
   * @param qParam Query params
   */
  getDonorSummary(qParam?) {
    this.util.isToken = true;
    const url = this.APIURL + API_ENDTPOINTS.GET_USER_SUMMARY;
    return this.http.get(url + qParam, this.httpOptions);
  }

  /**
   * Get the recurring contribute deatils
   * @param qParam Query params
   */
  getContributeDetails(qParam?) {
    this.util.isToken = true;
    const url = this.APIURL + API_ENDTPOINTS.GET_RECURRING_CONTRIBUTE_DETAILS;
    return this.http.get(url + qParam, this.httpOptions);
  }
  /**Get the campaigns */
  getCampaigns(qParam) {
    const url = this.APIURL + API_ENDTPOINTS.GET_CAMPAIGNS;
    return this.http.get(url + qParam, this.httpOptions);
  }

  getTickrData(params?) {
    const url = this.APIURL + API_ENDTPOINTS.PORTFOLIO_TICKR + `?country_code=${params?.country_code || ''}`;
    return this.http.get(url, this.httpOptions);
  }

  getSuccessStories(qParam) {
    const url = this.APIURL + API_ENDTPOINTS.SUCCESS_STORIES;
    return this.http.get(url + qParam, this.httpOptions);
  }

  getUserSubscription(id, qParam) {
    const url = this.APIURL + API_ENDTPOINTS.GET_USER_SUBSCRIPTION(id);
    return this.http.get(url + qParam, this.httpOptions);
  }

  increasePledge(id, data) {
    const url = this.APIURL + API_ENDTPOINTS.INCREASE_PLEDGE(id);
    return this.http.put(url, data, this.httpOptions);
  }

  redeemAmount(data) {
    const url = this.APIURL + API_ENDTPOINTS.AMOUNT_REDEEM;
    return this.http.post(url, data, this.httpOptions);
  }
}
